import { APP_NAME } from '../config/brand'

export type DashboardTitle = {
  title: string
  subtitle: string
}

export function matchDashboardTitle(pathname: string): DashboardTitle {
  const titles: Record<string, DashboardTitle> = {
    '/': { title: 'Dashboard', subtitle: 'Overview and quick actions' },
    '/organizations': { title: 'Organizations', subtitle: `Manage the businesses on ${APP_NAME}` },
    '/payment-gateways': { title: 'Payment methods', subtitle: 'Ways customers can pay at checkout' },
    '/withdrawals': { title: 'Withdrawals', subtitle: 'Approve merchant payout requests and record disbursement' },
    '/newsletters': { title: 'Newsletter', subtitle: 'Platform-wide storefront newsletter subscriptions' },
    '/legal/imprint': { title: 'Imprint', subtitle: 'Legal imprint shown on all storefronts' },
    '/legal/pricing': { title: 'Pricing', subtitle: 'Marketing site subscription plans and amounts' },
    '/settings': { title: 'Settings', subtitle: 'Your account and preferences' },
    '/platform/team': { title: 'Platform team', subtitle: 'Invite and manage super admins' },
  }
  if (titles[pathname]) return titles[pathname]
  if (pathname.startsWith('/organizations/new'))
    return { title: 'New organization', subtitle: `Add a new business to ${APP_NAME}` }
  if (pathname.match(/^\/organizations\/[^/]+\/edit$/))
    return { title: 'Edit organization', subtitle: 'Change business details and features' }
  if (pathname.match(/^\/organizations\/[^/]+\/stores\/[^/]+\/edit$/))
    return { title: 'Edit store', subtitle: 'Web address, currency, and contact details' }
  if (pathname.match(/^\/withdrawals\/audit\/[^/]+\/transactions\/[^/]+$/))
    return { title: 'Transaction detail', subtitle: 'Ledger, POS, and withdrawal investigation' }
  if (pathname.match(/^\/withdrawals\/audit\/[^/]+$/))
    return { title: 'Store audit', subtitle: 'Harmonized transactions and orders for payout review' }
  if (pathname.match(/^\/organizations\/[^/]+\/stores\/[^/]+\/webhook-logs$/))
    return { title: 'Webhook logs', subtitle: 'Payment provider webhook delivery history for this store' }
  if (pathname.match(/^\/organizations\/[^/]+\/stores\/[^/]+\/pos-remittance$/))
    return { title: 'POS remittance', subtitle: 'Cash and bank transfers by staff member' }
  if (pathname.match(/^\/organizations\/[^/]+\/stores\/[^/]+$/))
    return { title: 'Store details', subtitle: 'Store setup, merchandising, and platform tools' }
  if (pathname.match(/^\/organizations\/[^/]+$/))
    return { title: 'Organization details', subtitle: 'Summary of this business’s setup' }
  return { title: 'Dashboard', subtitle: '' }
}
